<div class="help-flow">
  <div class="grid margin-bottom-xsmall">
    <div class="cell margin-right-medium margin-left-xmedium progress-nav">
      <button mat-icon-button color="primary" *ngIf="(helpFlow && helpFlow.activeStepIndex > 0) || isAuthenticated" (click)="goBack()">
        <mat-icon>west</mat-icon>
      </button>
    </div>
  </div>
  <div class="grid align-center padding-bottom-xxbig help-flow-content">
    <div class="cell cell-large-col-span-12">
      <ng-container *ngIf="!loading">
        
        <ng-container *ngIf="helpQuestion && activeHelpStep.type === 'question'">
          <app-help-question [activeQuestion]="helpQuestion" [form]="form"></app-help-question>
        </ng-container>

        <ng-container *ngIf="activeHelpStep?.type === 'auth'">
          <div class="padding-xxbig flex flex-justify-center flex-content-center">
            <mat-spinner diameter="50"></mat-spinner>
          </div>
        </ng-container>

        <ng-container *ngIf="activeHelpStep?.type === 'list'">
          <app-help-reference-list [policies]="eligiblePolicies" [claims]="claims"></app-help-reference-list>
        </ng-container>

        <ng-container *ngIf="activeHelpStep?.type === 'contact'">
          <app-help-contact></app-help-contact>
        </ng-container>
        
      </ng-container>

      <ng-container *ngIf="loading">
        <div class="padding-xxbig flex flex-justify-center">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
      </ng-container>
    </div>
  </div>
</div>
